var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('MetadataForm',{ref:"form",attrs:{"polygon-id":_vm.polygonId,"pre-selected-date":_vm.preSelectedDate,"date-list":_vm.dateList,"pre-loaded-polygon-data":_vm.selectedPolygon,"other-metadata":_vm.other_metadata},on:{"date-changed":function($event){_vm.currentDate = $event}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }